import React from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';

const styles = (theme) => ({
    textField: {
        width: '100%',
        maxWidth: '100%',
        marginTop: 0,
        marginBottom: 0,
        background: '#FAFAFA',
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12)',
        borderRadius: 2,
    },
    menu: {
        width: 250,
    },
    cssSelect: {
        '&:focus': {
            background: 'inherit',
        },
    },
    cssSelectRoot: {
        backgroundColor: 'inherit',
        borderRadius: 'inherit',
        '&:hover': {
            backgroundColor: 'inherit',
            borderBottom: 'none',
        },
        '&$focused': {
            backgroundColor: 'inherit',
        },
        '&$disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.03)',
        },
    },
    cssUnderline: {
        '&:before': {
            borderBottom: 'none',
        },
        '&:after': {
            borderBottom: 'none',
        },
        '&:hover:not([disabled]):not([focused]):not([error]):before': {
            borderBottom: `inherit !important`,
        },
    },
    disabled: {},
    focused: {},
});

/**
 * FormItemSelect
 * - comon component for inputs within console app
 * @param {{ form: object, label: string, placeholder: string }} props
 */
const FormItemSelect = ({
    form,
    intl,
    formItemKey,
    initialValue,
    label,
    helperText = '',
    placeholder,
    addonBefore,
    additionalRules = [],
    classes,
    type = 'text',
    fullWidth = true,
    isRequired = false,
    optionList,
    optionListIsLoading = false,
    onChange,
    validateTrigger = 'onChange',
}) => {
    const { getFieldDecorator } = form;

    const errors = form.getFieldError(formItemKey);
    return (
        <div className="yeself-textField">
            {getFieldDecorator(formItemKey, {
                initialValue: initialValue || undefined,
                validateTrigger,
                preserve: true,
                rules: [
                    {
                        required: isRequired,
                        message: intl.formatMessage({ id: 'Form.field.isRequired' }),
                    },
                    ...(additionalRules && additionalRules.length > 0 ? additionalRules : []),
                ],
            })(
                <TextField
                    className={classes.textField}
                    required={isRequired}
                    onChange={onChange}
                    id={`form-item-input-${formItemKey}`}
                    label={
                        optionListIsLoading
                            ? intl.formatMessage({ id: 'Form.field.isLoading' })
                            : label || undefined
                    }
                    fullWidth={fullWidth}
                    disabled={optionListIsLoading}
                    select
                    error={errors && errors.length > 0}
                    helperText={errors && errors.length > 0 ? errors.join(',') : helperText}
                    placeholder={placeholder || undefined}
                    margin="normal"
                    type={type}
                    variant="filled"
                    InputProps={{
                        startAdornment: addonBefore ? (
                            <InputAdornment position="start">{addonBefore}</InputAdornment>
                        ) : undefined,
                        classes: {
                            root: classes.cssSelectRoot,
                            underline: classes.cssUnderline,
                        },
                    }}
                    SelectProps={{
                        MenuProps: {
                            className: classes.menu,
                        },
                    }}
                    InputLabelProps={
                        fullWidth
                            ? {
                                  shrink: true,
                              }
                            : {}
                    }
                >
                    {!optionListIsLoading && optionList && optionList.length > 0 ? (
                        optionList.map((option) => (
                            <MenuItem
                                id="yeself-menu-item"
                                key={option.id || option.value}
                                value={option.value}
                            >
                                {option.name}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem id="yeself-menu-item" disabled />
                    )}
                </TextField>
            )}
        </div>
    );
};
export default withStyles(styles)(injectIntl(FormItemSelect));
